var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',[_c('h2',[_vm._v("Lista projektów z udziałem wolontariusza "+_vm._s(_vm.volunteerName))])]),_c('ProjectTable',{attrs:{"volunteer":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }